import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=7f498b90&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=ts"
export * from "./Portal.vue?vue&type=script&lang=ts"
import style0 from "./Portal.vue?vue&type=style&index=0&id=7f498b90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f498b90",
  null
  
)

export default component.exports